
import Vue from 'vue'

const getDefaultState = () => {
    return {
        marketing: {
            id: 0,
            title: ""
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List(_, { idService, showOnlyActive = true }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`marketing/list/${idService}/${showOnlyActive}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listMarketing = result.data.result;

                return listMarketing;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list marketing: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`marketing/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get marketing`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get marketing: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, marketingRequest) {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`marketing/create-update`, marketingRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let msg = "Register updated with success!";

                if (marketingRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    idMarketing: result.data.result,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async UpdateStatus(_, { id, statusId }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`marketing/update-status/${id}/${statusId}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.marketing, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.marketing;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}